<template>
  <div id="leftTop">
    <div class="bg-color-black">
      <div class="weather-box">
        <dv-border-box-6>
          <div class="top">
            <div class="temp d-flex ai-center jc-center">42</div>
            <div class="eva d-flex ai-end jc-center">
              <span>优</span>
            </div>
            <div class="position">
              <img :src="positionUrl" />
              北京
            </div>
          </div>
        </dv-border-box-6>
        <dv-border-box-6>
          <div class="btm d-flex jc-around">
            <div class="flex-1 d-flex jc-center ai-center" style="font-size: 30px; text-align: center;">
              <span>未来三天天气预报</span>
            </div>
            <div class="flex-1 d-flex jc-around ai-center">
              <img v-for="img in img3" :key="img" :src="img" />
            </div>
          </div>
        </dv-border-box-6>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  data() {
    return {
      positionUrl: require('../../../assets/定位.png'),
      img3: [
        require('../../../assets/future1.png'),
        require('../../../assets/future2.png'),
        require('../../../assets/future3.png')
      ]
    }
  }
}
</script>
    
<style lang="scss" scoped>
$box-height: 450px;
$box-width: 100%;

#leftTop {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

  .weather-box {
    margin-top: 16px;

    .dv-border-box-6 {
      padding: 10px;
    }

    .top {
      display: grid;
      grid-template-columns: repeat(3, 33.3%);

      div {
        height: 250px;
      }

      .temp {
        font-size: 150px;
      }

      .eva {
        padding-bottom: 20px;

        span {
          display: inline-block;
          height: 50px;
          width: 200px;
          text-align: center;
          font-size: 28px;
          line-height: 50px;
          border-radius: 20px;
          overflow: hidden;
          background: #0aca3d;
        }
      }

      .position {
        font-size: 36px;
        padding-top: 30px;
        padding-right: 20px;
        position: relative;
        text-align: right;

        img {
          position: absolute;
          top: 9px;
          height: 60px;
          right: 95px;
        }
      }
    }

    .btm {
      div {
        height: 100px;
      }

      img {
        height: 70px;
      }
    }

    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>
    